// import React, { useState } from 'react';
// import axios from 'axios';
// import './OfferManagement.css';

// // Use environment variable for API URL in production
// const API_URL = 'https://apitop.topranohotelandlounge.com';

// const OfferManagement = ({ offers, onUpdate }) => {
//   const [formData, setFormData] = useState({
//     title: '',
//     description: '',
//     isActive: true,
//     expiresAt: '',
//   });
//   const [editingOffer, setEditingOffer] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [message, setMessage] = useState('');
//   const [error, setError] = useState('');

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     setMessage('');
//     setError('');

//     try {
//       if (editingOffer) {
//         await axios.put(`${API_URL}/api/offers/${editingOffer._id}`, formData);
//         setMessage('Offer updated successfully!');
//       } else {
//         await axios.post(`${API_URL}/api/offers`, formData);
//         setMessage('Offer created successfully!');
//       }
//       setFormData({ title: '', description: '', isActive: true, expiresAt: '' });
//       setEditingOffer(null);
//       onUpdate();
//     } catch (error) {
//       console.error('Error saving offer:', error);
//       setError(error.response?.data?.error || 'Failed to save offer');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleEdit = (offer) => {
//     setFormData({
//       title: offer.title,
//       description: offer.description,
//       isActive: offer.isActive,
//       expiresAt: new Date(offer.expiresAt).toISOString().slice(0, 16), // Format for datetime-local
//     });
//     setEditingOffer(offer);
//     setMessage('');
//     setError('');
//   };

//   const handleDelete = async (id) => {
//     if (!window.confirm('Are you sure you want to delete this offer?')) return;
//     setMessage('');
//     setError('');
//     try {
//       await axios.delete(`${API_URL}/api/offers/${id}`);
//       setMessage('Offer deleted successfully!');
//       onUpdate();
//     } catch (error) {
//       console.error('Error deleting offer:', error);
//       setError(error.response?.data?.error || 'Failed to delete offer');
//     }
//   };

//   const handleToggleStatus = async (id, currentStatus) => {
//     setMessage('');
//     setError('');
//     try {
//       await axios.put(`${API_URL}/api/offers/${id}`, { isActive: !currentStatus });
//       setMessage(`Offer ${currentStatus ? 'deactivated' : 'activated'} successfully!`);
//       onUpdate();
//     } catch (error) {
//       console.error('Error updating offer status:', error);
//       setError(error.response?.data?.error || 'Failed to update offer status');
//     }
//   };

//   if (!offers) {
//     return <div className="offer-management">Loading offers...</div>;
//   }

//   return (
//     <div className="offer-management">
//       <div className="admin-form">
//         <h2 className="form-title">{editingOffer ? 'Edit Offer' : 'Create New Offer'}</h2>
//         {message && <div className="alert alert-success">{message}</div>}
//         {error && <div className="alert alert-error">{error}</div>}
//         <form onSubmit={handleSubmit} className="form-container">
//           <div className="form-group">
//             <label htmlFor="title">Offer Title</label>
//             <input
//               type="text"
//               id="title"
//               placeholder="Enter offer title"
//               value={formData.title}
//               onChange={(e) => setFormData({ ...formData, title: e.target.value })}
//               className="form-input"
//               required
//             />
//           </div>
//           <div className="form-group">
//             <label htmlFor="description">Description</label>
//             <textarea
//               id="description"
//               placeholder="Enter offer description"
//               value={formData.description}
//               onChange={(e) => setFormData({ ...formData, description: e.target.value })}
//               className="form-textarea"
//               required
//               rows="4"
//             />
//           </div>
//           <div className="form-grid">
//             <div className="form-group">
//               <label htmlFor="expiresAt">Expiration Date</label>
//               <input
//                 type="datetime-local"
//                 id="expiresAt"
//                 value={formData.expiresAt}
//                 onChange={(e) => setFormData({ ...formData, expiresAt: e.target.value })}
//                 className="form-input"
//                 required
//               />
//             </div>
//             <div className="form-group form-checkbox">
//               <label>
//                 <input
//                   type="checkbox"
//                   checked={formData.isActive}
//                   onChange={(e) => setFormData({ ...formData, isActive: e.target.checked })}
//                 />
//                 Active Offer
//               </label>
//             </div>
//           </div>
//           <div className="form-buttons">
//             <button
//               type="submit"
//               disabled={loading}
//               className="btn btn-success"
//             >
//               {loading ? 'Saving...' : editingOffer ? 'Update Offer' : 'Create Offer'}
//             </button>
//             {editingOffer && (
//               <button
//                 type="button"
//                 onClick={() => {
//                   setFormData({ title: '', description: '', isActive: true, expiresAt: '' });
//                   setEditingOffer(null);
//                 }}
//                 className="btn btn-secondary"
//               >
//                 Cancel
//               </button>
//             )}
//           </div>
//         </form>
//       </div>
//       <div className="list-container">
//         <h2 className="list-title">All Offers ({offers.length})</h2>
//         {offers.length === 0 ? (
//           <p className="no-offers">No offers found. Create your first offer!</p>
//         ) : (
//           offers.map((offer) => (
//             <div key={offer._id} className="list-item">
//               <div className="list-item-header">
//                 <h3 className="list-item-title">{offer.title}</h3>
//                 <div className="list-item-actions">
//                   <button
//                     onClick={() => handleEdit(offer)}
//                     className="btn btn-primary"
//                   >
//                     Edit
//                   </button>
//                   <button
//                     onClick={() => handleToggleStatus(offer._id, offer.isActive)}
//                     className={`btn ${offer.isActive ? 'btn-warning' : 'btn-secondary'}`}
//                   >
//                     {offer.isActive ? 'Deactivate' : 'Activate'}
//                   </button>
//                   <button
//                     onClick={() => handleDelete(offer._id)}
//                     className="btn btn-danger"
//                   >
//                     Delete
//                   </button>
//                 </div>
//               </div>
//               <p className="list-item-content">{offer.description}</p>
//               <div className="list-item-meta">
//                 <span className={`badge ${offer.isActive ? 'badge-success' : 'badge-secondary'}`}>
//                   {offer.isActive ? 'Active' : 'Inactive'}
//                 </span>
//                 <span>Expires: {new Date(offer.expiresAt).toLocaleDateString()}</span>
//                 <span>Created: {new Date(offer.createdAt).toLocaleDateString()}</span>
//               </div>
//             </div>
//           ))
//         )}
//       </div>
//     </div>
//   );
// };

// export default OfferManagement;


import React, { useState } from 'react';
import axios from 'axios';
import './OfferManagement.css';

// Use environment variable for API URL in production
const API_URL = 'https://apitop.topranohotelandlounge.com';

const OfferManagement = ({ offers, onUpdate }) => {
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    isActive: true,
    expiresAt: '',
  });
  const [editingOffer, setEditingOffer] = useState(null);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');
    setError('');

    try {
      if (editingOffer) {
        await axios.put(`${API_URL}/api/offers/${editingOffer._id}`, formData);
        setMessage('Offer updated successfully!');
      } else {
        await axios.post(`${API_URL}/api/offers`, formData);
        setMessage('Offer created successfully!');
      }
      setFormData({ title: '', description: '', isActive: true, expiresAt: '' });
      setEditingOffer(null);
      onUpdate();
    } catch (error) {
      console.error('Error saving offer:', error);
      setError(error.response?.data?.error || 'Failed to save offer');
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (offer) => {
    setFormData({
      title: offer.title,
      description: offer.description,
      isActive: offer.isActive,
      expiresAt: new Date(offer.expiresAt).toISOString().slice(0, 16), // Format for datetime-local
    });
    setEditingOffer(offer);
    setMessage('');
    setError('');
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this offer?')) return;
    setMessage('');
    setError('');
    try {
      await axios.delete(`${API_URL}/api/offers/${id}`);
      setMessage('Offer deleted successfully!');
      onUpdate();
    } catch (error) {
      console.error('Error deleting offer:', error);
      setError(error.response?.data?.error || 'Failed to delete offer');
    }
  };

  const handleToggleStatus = async (id, currentStatus) => {
    setMessage('');
    setError('');
    try {
      await axios.put(`${API_URL}/api/offers/${id}`, { isActive: !currentStatus });
      setMessage(`Offer ${currentStatus ? 'deactivated' : 'activated'} successfully!`);
      onUpdate();
    } catch (error) {
      console.error('Error updating offer status:', error);
      setError(error.response?.data?.error || 'Failed to update offer status');
    }
  };

  if (!offers) {
    return <div className="offer-management">Loading offers...</div>;
  }

  return (
    <div className="offer-management">
      <div className="admin-form">
        <h2 className="form-title">{editingOffer ? 'Edit Offer' : 'Create New Offer'}</h2>
        {message && <div className="alert alert-success">{message}</div>}
        {error && <div className="alert alert-error">{error}</div>}
        <form onSubmit={handleSubmit} className="form-container">
          <div className="form-group">
            <label htmlFor="title" className="form-label">Offer Title *</label>
            <input
              type="text"
              id="title"
              placeholder="Enter offer title"
              value={formData.title}
              onChange={(e) => setFormData({ ...formData, title: e.target.value })}
              className="form-input"
              required
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="description" className="form-label">Description *</label>
            <textarea
              id="description"
              placeholder="Enter offer description"
              value={formData.description}
              onChange={(e) => setFormData({ ...formData, description: e.target.value })}
              className="form-textarea"
              required
              rows="4"
            />
          </div>
          
          <div className="form-grid">
            <div className="form-group">
              <label htmlFor="expiresAt" className="form-label">Expiration Date *</label>
              <input
                type="datetime-local"
                id="expiresAt"
                value={formData.expiresAt}
                onChange={(e) => setFormData({ ...formData, expiresAt: e.target.value })}
                className="form-input"
                required
              />
            </div>
            
            <div className="form-group">
              <label className="form-label">Status</label>
              <div className="checkbox-container">
                <label className="checkbox-label">
                  <input
                    type="checkbox"
                    checked={formData.isActive}
                    onChange={(e) => setFormData({ ...formData, isActive: e.target.checked })}
                    className="checkbox-input"
                  />
                  <span className="checkbox-custom"></span>
                  Active Offer
                </label>
              </div>
            </div>
          </div>
          
          <div className="form-buttons">
            <button
              type="submit"
              disabled={loading}
              className="btn btn-success"
            >
              {loading ? 'Saving...' : editingOffer ? 'Update Offer' : 'Create Offer'}
            </button>
            {editingOffer && (
              <button
                type="button"
                onClick={() => {
                  setFormData({ title: '', description: '', isActive: true, expiresAt: '' });
                  setEditingOffer(null);
                }}
                className="btn btn-secondary"
              >
                Cancel
              </button>
            )}
          </div>
        </form>
      </div>
      
      <div className="list-container">
        <h2 className="list-title">All Offers ({offers.length})</h2>
        {offers.length === 0 ? (
          <div className="empty-state">
            <p>No offers found. Create your first offer!</p>
          </div>
        ) : (
          offers.map((offer) => (
            <div key={offer._id} className="list-item">
              <div className="list-item-header">
                <div className="list-item-title-section">
                  <h3 className="list-item-title">{offer.title}</h3>
                  <span className={`badge ${offer.isActive ? 'badge-success' : 'badge-secondary'}`}>
                    {offer.isActive ? 'Active' : 'Inactive'}
                  </span>
                </div>
                <div className="list-item-actions">
                  <button
                    onClick={() => handleEdit(offer)}
                    className="btn btn-primary"
                  >
                    Edit
                  </button>
                  <button
                    onClick={() => handleToggleStatus(offer._id, offer.isActive)}
                    className={`btn ${offer.isActive ? 'btn-warning' : 'btn-secondary'}`}
                  >
                    {offer.isActive ? 'Deactivate' : 'Activate'}
                  </button>
                  <button
                    onClick={() => handleDelete(offer._id)}
                    className="btn btn-danger"
                  >
                    Delete
                  </button>
                </div>
              </div>
              
              <p className="list-item-content">{offer.description}</p>
              
              <div className="list-item-meta">
                <div className="meta-item">
                  <span className="meta-label">Expires:</span>
                  <span className="meta-value">{new Date(offer.expiresAt).toLocaleDateString()}</span>
                </div>
                <div className="meta-item">
                  <span className="meta-label">Created:</span>
                  <span className="meta-value">{new Date(offer.createdAt).toLocaleDateString()}</span>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default OfferManagement;